/* @flow */

import React from 'react'
import PropTypes from 'prop-types'
// import { View, TouchableOpacity, Text } from 'react-native'
import { Text, View } from '../../Components'

import { Colors } from '../../global'

const styles = {
  tabStyle: {
    paddingVertical: 5,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    //borderColor: Colors.transparent,
    //borderWidth: 0,
    backgroundColor: Colors.accent,
  },
  activeTabStyle: {
    backgroundColor: Colors.accentDark,
  },
  tabTextStyle: {
    color: Colors.light,
  },
  activeTabTextStyle: {
    color: Colors.light,
  },
}

const TabOption = ({
  isTabActive,
  index,
  text,
  firstTabStyle,
  lastTabStyle,
  tabStyle,
  activeTabStyle,
  tabTextStyle,
  activeTabTextStyle,
  onTabPress,
  textNumberOfLines,
  allowFontScaling,
  accessible,
  activeTabOpacity,
  accessibilityLabel,
  enabled,
  ...rest
}) => {
  return (
    <View
      style={[
        styles.tabStyle,
        tabStyle,
        isTabActive ? [styles.activeTabStyle, activeTabStyle] : {},
        firstTabStyle,
        lastTabStyle,
      ]}
      accessible={accessible}
      accessibilityLabel={accessibilityLabel}
      accessibilityTraits={isTabActive ? 'selected' : 'button'}
      accessibilityComponentType="button"
      onPress={() => onTabPress(index)}
      disabled={!enabled}
      activeOpacity={activeTabOpacity}
    >
      <View style={{ flexDirection: 'row' }}>
        <Text
          style={[
            styles.tabTextStyle,
            tabTextStyle,
            isTabActive ? [styles.activeTabTextStyle, activeTabTextStyle] : {},
          ]}
          // numberOfLines={textNumberOfLines}
          allowFontScaling={allowFontScaling}
          ellipsizeMode="tail"
          as={'small'}
        >
          {text}
        </Text>
      </View>
    </View>
  )
}

TabOption.defaultProps = {
  isTabActive: false,
  index: 0,
  firstTabStyle: {},
  lastTabStyle: {},
  tabStyle: {},
  activeTabStyle: {},
  tabTextStyle: {},
  activeTabTextStyle: {},
  textNumberOfLines: 1,
  allowFontScaling: false,
  accessible: true,
  activeTabOpacity: 5,
  accessibilityLabel: '',
  enabled: false,
  onTabPress: () => {},
}

TabOption.propTypes = {
  isTabActive: PropTypes.bool,
  index: PropTypes.number,
  text: PropTypes.string,
  firstTabStyle: PropTypes.object,
  lastTabStyle: PropTypes.object,
  tabStyle: PropTypes.arrayOf(PropTypes.object),
  activeTabStyle: PropTypes.object,
  tabTextStyle: PropTypes.object,
  activeTabTextStyle: PropTypes.object,
  onTabPress: PropTypes.func.isRequired,
  textNumberOfLines: PropTypes.number,
  allowFontScaling: PropTypes.bool,
  accessible: PropTypes.bool,
  activeTabOpacity: PropTypes.number,
  accessibilityLabel: PropTypes.string,
  enabled: PropTypes.bool,
}

export default TabOption
